<template>
  <PageHeader :showBreadcrumb="true" />
  <LoaderOverlay :visible="formState.state.loading" :message="formState.state.loadingMessage" />

  <div class="container p-3">
    <form @submit.stop.prevent="onSubmit">
      <MnRow v-if="!appStore.loading">
        <MnColumn cols="6">
          <ValidatedInput
            id="entity-input"
            label="Name of the Entity"
            v-model="formState.state.data.entityId"
            :validation="formState.state.$v.entityId"
            :inputComponent="Select"
            :inputAttrs="{
              inputId: 'entity-input',
              ariaLabel: 'Name of the Entity',
              options: entityOptions,
              placeholder: '-- Select Entity --',
              optionLabel: 'name',
              optionValue: 'id'
            }"
          />
        </MnColumn>
      </MnRow>
      <MnRow v-else>
        <MnColumn cols="6">
          <p>Loading entities...</p>
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <ValidatedInput
            id="exam-type-input"
            label="Exam Type"
            v-model="formState.state.data.examType"
            :validation="formState.state.$v.examType"
            :inputComponent="Select"
            :inputAttrs="{
              inputId: 'exam-type-input',
              ariaLabel: 'Exam Type',
              options: examTypeOptions,
              placeholder: '-- Select Exam Type --',
              optionLabel: 'label',
              optionValue: 'value'
            }"
          />
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <ValidatedInput
            id="exam-product-input"
            label="Exam Product (Select more than one)"
            v-model="formState.state.data.examProducts"
            :validation="formState.state.$v.examProducts"
            :inputComponent="MultiSelect"
            :inputAttrs="{
              inputId: 'exam-product-input',
              ariaLabel: 'Exam Product',
              options: availableExamProducts,
              placeholder: '-- Select Exam Products --',
              optionLabel: 'label',
              optionValue: 'value',
              maxSelectedLabels: 3,
              showClear: false,
              class: 'w-100'
            }"
          />
        </MnColumn>
      </MnRow>

      <hr class="my-4" />
      <h4>Examination Dates</h4>

      <MnRow>
        <MnColumn cols="6">
          <ValidatedInput
            id="virtual-exam-date-input"
            label="Virtual Exam Date"
            v-model="formState.state.data.virtualExamDate"
            :validation="formState.state.$v.virtualExamDate"
            :inputComponent="DatePicker"
            :inputAttrs="{
              inputId: 'virtual-exam-date-input',
              ariaLabel: 'Virtual Exam Date',
              placeholder: 'MM/DD/YYYY',
              dateFormat: 'mm/dd/yy',
              showIcon: true,
              showButtonBar: true
            }"
          />
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <ValidatedInput
            id="file-review-start-input"
            label="File Review Period - Start Date"
            v-model="formState.state.data.fileReviewPeriodStartDate"
            :validation="formState.state.$v.fileReviewPeriodStartDate"
            :inputComponent="DatePicker"
            :inputAttrs="{
              inputId: 'file-review-start-input',
              ariaLabel: 'File Review Period Start Date',
              placeholder: 'MM/DD/YYYY',
              dateFormat: 'mm/dd/yy',
              showIcon: true,
              showButtonBar: true
            }"
          />
        </MnColumn>
        <MnColumn cols="6">
          <ValidatedInput
            id="file-review-end-input"
            label="File Review Period - End Date"
            v-model="formState.state.data.fileReviewPeriodEndDate"
            :validation="formState.state.$v.fileReviewPeriodEndDate"
            :inputComponent="DatePicker"
            :inputAttrs="{
              inputId: 'file-review-end-input',
              ariaLabel: 'File Review Period End Date',
              placeholder: 'MM/DD/YYYY',
              dateFormat: 'mm/dd/yy',
              showIcon: true,
              showButtonBar: true
            }"
          />
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <ValidatedInput
            id="phase-input"
            label="Phase of the exam"
            v-model="formState.state.data.phase"
            :validation="formState.state.$v.phase"
            :inputComponent="Select"
            :inputAttrs="{
              inputId: 'phase-input',
              ariaLabel: 'Phase of the exam',
              options: phaseOptions,
              placeholder: '-- Select Phase --',
              optionLabel: 'label',
              optionValue: 'value'
            }"
          />
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <ValidatedInput
            id="informational-meeting-date-input"
            label="Informational Meeting Date"
            v-model="formState.state.data.informationalMeetingDate"
            :validation="formState.state.$v.informationalMeetingDate"
            :inputComponent="DatePicker"
            :inputAttrs="{
              inputId: 'informational-meeting-date-input',
              ariaLabel: 'Informational Meeting Date',
              placeholder: 'MM/DD/YYYY',
              dateFormat: 'mm/dd/yy',
              showIcon: true,
              showButtonBar: true
            }"
          />
        </MnColumn>
      </MnRow>

      <MnRow>
        <MnColumn cols="6">
          <ValidatedInput
            id="opening-date-input"
            label="Opening Date"
            v-model="formState.state.data.openingDate"
            :validation="formState.state.$v.openingDate"
            :inputComponent="DatePicker"
            :inputAttrs="{
              inputId: 'opening-date-input',
              ariaLabel: 'Opening Date',
              placeholder: 'MM/DD/YYYY',
              dateFormat: 'mm/dd/yy',
              showIcon: true,
              showButtonBar: true
            }"
          />
        </MnColumn>
      </MnRow>

      <hr class="my-4" />

      <MnRow>
        <MnColumn cols="12">
          <div class="d-flex my-3">
            <Button type="submit" size="lg" class="me-2" rounded raised label="Save" />
            <Button type="button" rounded severity="secondary" size="lg" label="Cancel" @click="router.push({ path: '/QualityAssurance', force: true})" />
          </div>
        </MnColumn>
      </MnRow>
    </form>
  </div>

  <!-- Success Modal -->
  <Dialog v-model:visible="isSubmissionCompleteOpen" modal header="Exam Created Successfully" :closable="false" :style="{ width: '30rem' }">
    <div class="row mb-8">
      <div class="col-2">
        <i :class="[ICONS.CheckCircle, 'color-success', 'fs-1']"></i>
      </div>
      <div class="col-10">
        <p>
          The exam has been created successfully with ID #<b>{{ savedExamId }}</b>. Please keep this ID for your records.
        </p>
      </div>
    </div>
    <template #footer>
      <div class="d-flex justify-content-end">
        <Button type="button" class="me-2" rounded raised @click="closeDialog(); router.push({ path: '/QualityAssurance', force: true });" label="Done" severity="secondary"/>
      </div>
    </template>
  </Dialog>

  <!-- Error Modal -->
  <Dialog v-model:visible="isSubmissionErrorOpen" modal header="Error Creating Exam" :closable="false" :style="{ width: '30rem' }">
    <div class="row mb-8">
      <div class="col-2">
        <i :class="[ICONS.ErrorCircle, 'color-danger', 'fs-1']"></i>
      </div>
      <div class="col-10">
        <p>
          {{ errorMessage || 'An error has occurred while creating the exam. Please try again.' }}
        </p>
      </div>
    </div>
    <template #footer>
      <div class="d-flex justify-content-end">
        <Button type="button" class="me-2" rounded raised @click="closeDialog();" label="Done" severity="secondary"/>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useForm } from '@/composables/form';
import { useAppStore } from '@/stores/appStore';
import { useDialogStore } from '@/stores/dialogStore';
import { useToast } from 'primevue/usetoast';
import {
  TOAST_SAVE_LIFE, EXAM_TYPES, EXAM_PRODUCTS, EXAM_PHASES,
  getAsFormOptions, ICONS
} from '@/utils/constants';
import { ExamModel } from '@/models/ExamModel';
import { insertExam } from '@/services/examService';

import PageHeader from '@/components/common/PageHeader.vue';
import LoaderOverlay from '@/components/common/LoaderOverlay.vue';
import MnRow from '@/components/common/MnRow.vue';
import MnColumn from '@/components/common/MnColumn.vue';
import ValidatedInput from '@/components/common/ValidatedInput.vue';
import Button from 'primevue/button';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import DatePicker from 'primevue/datepicker';
import Dialog from 'primevue/dialog';

const router = useRouter();
const appStore = useAppStore();
const toast = useToast();
const dialogStore = useDialogStore();

const formState = useForm(new ExamModel(), ExamModel.getValidationRules());

// State for modal dialogs
const savedExamId = ref(null);
const errorMessage = ref(null);

// Dialog helpers
const toggleDialog = (name) => dialogStore.toggle(name);
const closeDialog = () => dialogStore.close();
const isSubmissionCompleteOpen = computed(() => dialogStore.isOpen('submissionComplete'));
const isSubmissionErrorOpen = computed(() => dialogStore.isOpen('submissionError'));

// Entity options - ALL HMO and CBP entities (not filtered by user entities)
// MDH staff can create exams for any HMO/CBP entity
const entityOptions = computed(() => {
  return appStore.getEntities();
});

const examTypeOptions = getAsFormOptions(EXAM_TYPES);
const allExamProducts = getAsFormOptions(EXAM_PRODUCTS);

// Available exam products based on exam type selection
const availableExamProducts = computed(() => {
  const examType = formState.state.data.examType;

  if (examType === EXAM_TYPES.MidCycle) {
    // Mid-cycle cannot be combined with Full Cycle products
    return allExamProducts;
  } else if (examType === EXAM_TYPES.FullCycle) {
    // Full Cycle cannot be combined with Mid-cycle products
    return allExamProducts;
  }

  return allExamProducts;
});

// Phase options from constants using helper
const phaseOptions = getAsFormOptions(EXAM_PHASES);

const onSubmit = async () => {
  // Validate form
  const isValid = await formState.state.$v.$validate();

  if (!isValid) {
    toast.add({
      group: 'top-toast',
      severity: 'warn',
      summary: 'Validation Error',
      detail: 'Please correct the errors before saving.',
      life: TOAST_SAVE_LIFE
    });
    return;
  }

  try {
    formState.setLoadingState('Saving exam...');

    // Transform examProducts from array of strings to array of objects with productName
    const examData = {
      ...formState.state.data,
      examProducts: formState.state.data.examProducts.map(productName => ({
        productName: productName
      }))
    };

    // Call the service to insert exam
    const result = await insertExam(examData);

    if (result && result.id) {
      savedExamId.value = result.id;
      toggleDialog('submissionComplete');
    } else {
      errorMessage.value = 'Failed to create exam. Please try again.';
      toggleDialog('submissionError');
    }
  } catch (error) {
    console.error('Error creating exam:', error);
    errorMessage.value = error?.response?.data?.message || error?.message || 'An unexpected error occurred while creating the exam.';
    toggleDialog('submissionError');
  } finally {
    formState.hideLoadingState();
  }
};
</script>

<style scoped>
</style>
